(ns common.schema.entities.workspace.kyc.questions.flow-through-jurisdiction
  (:require
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(def all-questions
  {:kyc-flow-through-jurisdiction/jurisdiction
   {:data/type        :data.type/keyword
    :options          country/options
    :mandatory-field? true
    :translations     {:en "Jurisdiction"}}

   :kyc-flow-through-jurisdiction/ownership-percent
   {:data/type        :data.type/percentage
    :mandatory-field? true
    :translations     {:en "Ownership %"}
    :info             {:en "Determine %s by ref to % share of profits, voting rights and capital ownership (if different)"}}

   :kyc-flow-through-jurisdiction/taxable-percent
   {:data/type        :data.type/percentage
    :mandatory-field? false
    :translations     {:en "Taxable investors %"}}

   :kyc-flow-through-jurisdiction/tax-exempt-percent
   {:data/type        :data.type/percentage
    :mandatory-field? false
    :translations     {:en "Tax-Exempt investors %"}}

   :kyc-flow-through-jurisdiction/notes
   {:data/type        :data.type/text-multiline
    :mandatory-field? false
    :translations     {:en "Notes"}}

   :kyc-flow-through-jurisdiction/is-transparent
   {:data/type        :data.type/keyword
    :options          kyc-options/yes-no-options
    :mandatory-field? false
    :translations     {:en "Do the investors in the jurisdiction view the Partnership to be an entity which is, for the purposes of the tax laws of that jurisdiction, \"transparent\" for tax purposes?"}}

   :kyc-flow-through-jurisdiction/is-taxed-as-income-arises
   {:data/type        :data.type/keyword
    :options          kyc-options/yes-no-options
    :mandatory-field? false
    :conditional-field (fn [answers]
                         (= (:kyc-flow-through-jurisdiction/is-transparent answers) :yes))
    :translations     {:en "Would a taxable investor in the jurisdiction be taxed on the income of the Partnership as it arose to the Partnership (whether or not these amounts are distributed by the Partnership)?"}}})
